import { render } from "./tax-report.vue?vue&type=template&id=b32a003c"
import script from "./tax-report.vue?vue&type=script&lang=js"
export * from "./tax-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__